const EVENT_OPEN = "EVENT_OPEN";
const EVENT_CLOSE = "EVENT_CLOSE";
const EVENT_SUCCESS = "EVENT_SUCCESS";
const EVENT_ERROR = "EVENT_ERROR";

module.exports = {
  EVENT_OPEN,
  EVENT_CLOSE,
  EVENT_SUCCESS,
  EVENT_ERROR,
};
